import { render, staticRenderFns } from "./i18n.ko.vue?vue&type=template&id=c461f3ea&"
import script from "./i18n.ko.vue?vue&type=script&lang=js&"
export * from "./i18n.ko.vue?vue&type=script&lang=js&"
import style0 from "./i18n.ko.vue?vue&type=style&index=0&id=c461f3ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports